import React, { useState, useEffect } from 'react';
import OppTable from './OppTable';
import { UserView, UserViewType } from '../../types/user';
import { useAppDispatch } from '../../support/store';
import { checkTaggedOpportunitiesLoaded } from '../../support/slices/salesforceOpportunitiesSlice';
import UserViewNavigation from '../Common/UserViewNavigation';


interface OpportunityListPageProps {
  customerView?: boolean;
  branch: string | null;
}

const OpportunityListPage: React.FC<OpportunityListPageProps> = ({ branch }) => {
  const dispatch = useAppDispatch();
  const [selectedView, setSelectedView] = useState<UserView | null>(null);

  useEffect(() => {
    dispatch(checkTaggedOpportunitiesLoaded());
  }, [dispatch]);

  return (
    <>
      <UserViewNavigation
        viewType={UserViewType.Opportunity}
        selectedView={selectedView}
        setSelectedView={setSelectedView}
      />

      <div className="flex flex-col w-full h-full app-table-content">
        <OppTable
          isCustomerView={false}
          view={selectedView}
        />
      </div>
    </>
  );
}

export default OpportunityListPage;